module.exports = __webpack_public_path__ + "static/media/later-message.f9ca8ec9.svg";